import { InjectionToken } from '@angular/core';
import { ITDSIcons } from '../interfaces/itds-icons.interface';

export const ITDSIconsToken = new InjectionToken<ITDSIcons>('ITDSIcons');
